"use client"

import { Headphones } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HeadphonesIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HeadphonesIcon = component(Icon)({ as: Headphones })
